import { takeLatest, call, put, select } from 'redux-saga/effects'
import Api from '../../api'
import { handleResponseError } from '../create-request-saga'
// TODO: Figure logout reducer so it doesn't require user
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'

// action types
const RECEIVE_LEASE_PRODUCT_PERMISSIONS =
  'rp/leasePermissions/RECEIVE_LEASE_PRODUCT_PERMISSIONS'
const REQUEST_LEASE_PRODUCT_PERMISSIONS =
  'rp/leasePermissions/REQUEST_LEASE_PRODUCT_PERMISSIONS'

// reducer
export default (state = [], { type, payload }) => {
  switch (type) {
    case RECEIVE_LEASE_PRODUCT_PERMISSIONS:
      return [...state, ...payload]
    case LOGOUT:
      return []
    default:
      return state
  }
}

// action creators
export const requestLeaseProductPermissions = () => ({
  type: REQUEST_LEASE_PRODUCT_PERMISSIONS,
})

export const receiveLeaseProductPermissions = payload => ({
  type: RECEIVE_LEASE_PRODUCT_PERMISSIONS,
  payload,
})

// sagas
function* fetchLeaseProductPermissions() {
  try {
    const {
      userSettings: { isBulkPayment },
    } = yield select()
    let { lease_permissions = [] } = yield call(
      Api.getLeaseProductPermissions,
      { is_bulk_payment_workflow: isBulkPayment },
    )
    yield put(receiveLeaseProductPermissions(lease_permissions))
  } catch (error) {
    yield call(handleResponseError, error, { key: 'permissions' })
  }
}

function* watchLeasePermissions() {
  yield takeLatest(
    REQUEST_LEASE_PRODUCT_PERMISSIONS,
    fetchLeaseProductPermissions,
  )
}

export const sagas = [watchLeasePermissions]
